import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    marginLeft: theme.spacing(1.5),
  },
}))
